import Home from "./components/Home";
import SignUp from "./components/SignUp"
import Events from "./components/Events"

const AppRoutes = [
    {
        index: true,
        element: <Events />,
        path: '/'
    },
    {
        path: '/signuplinks',
        index: true,
        element: <SignUp />
    }
];

export default AppRoutes;
